import React from 'react';

import { AdminUser } from 'src/types/shared/AdminUser';

import ContentBlock from '@components/layout/contentBlock/ContentBlock';
import ContentItem from '@components/layout/contentBlock/ContentItem';
import ContentRow from '@components/layout/contentBlock/ContentRow';
import LinkButton from 'lib/src/components/button/LinkButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import Title from 'lib/src/components/typography/Title';
import { adminUserRoleNames } from 'lib/src/shared/enums/roleEnums';

const AdminUserComponent: React.FC<AdminUserProps> = ({ user }) => {
    if (!user) return null;

    const { id, firstName, lastName, email, roles } = user;
    return (
        <>
            <Title backHref="/admins">
                Admin - {firstName || ''} {lastName || ''}
            </Title>

            <ContentBlock>
                <ContentRow>
                    <ContentItem label="Name">
                        <p>{`${firstName || ''} ${lastName || ''}`}</p>
                    </ContentItem>
                    <ContentItem label="Email">
                        <p>
                            {email ? <a href={`mailto:${email}`}>{email}</a> : <p>No email set</p>}
                        </p>
                    </ContentItem>
                    <ContentItem label="Roles">
                        <p>
                            {roles
                                ? roles.map(role => adminUserRoleNames[role]).join(', ')
                                : 'No roles'}
                        </p>
                    </ContentItem>
                </ContentRow>
            </ContentBlock>

            <ButtonRow alignment="left">
                <LinkButton color="grey" href={`/admins/${id}/edit`}>
                    Edit
                </LinkButton>
                <LinkButton color="grey" href={`/admins/${id}/edit-password`}>
                    Edit password
                </LinkButton>
                <LinkButton color="red" href={`/admins/${id}/delete`}>
                    Delete
                </LinkButton>
            </ButtonRow>
        </>
    );
};

interface AdminUserProps {
    user: AdminUser | undefined;
}

export default AdminUserComponent;
